import axios from "axios";

import settings from "config/baseSettings";
import baseSettings from "config/baseSettings";
import store from "../redux/store";
// Import the action type only (not the action-creator module) to avoid a
// circular import: user.actions.js imports the axios instance from
// 'services', which imports this file.
import { UserActionTypes } from "../redux/user/user.types";

const axiosConfig = {
  baseURL: settings.baseUrl,
  timeout: baseSettings.axiosTimeout,
  timeoutErrorMessage: "Sorry! Unable to perform operation. Please try again.",
  // Auth is cookie-based (httpOnly adminAccessToken cookie set by the backend
  // on login) — the browser attaches it automatically, nothing to set here.
  withCredentials: true,
};

const isAuthCheckRequest = (config) => config?.url?.includes("/admin/me");
const isLoginRequest = (config) => config?.url?.includes("/admin/login");

class AxiosService {
  axiosInstance = {};

  constructor() {
    this.initInstance();
  }

  initInstance() {
    this.axiosInstance = axios.create(axiosConfig);

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        const { config, response } = error;

        // On an expired/invalid session, clear local auth state and send
        // the user back to login — except for the /admin/me check itself
        // (that's how we detect "no session" on app load) and the login
        // request (a failed login isn't a session expiry).
        if (
          response?.status === 401 &&
          !isAuthCheckRequest(config) &&
          !isLoginRequest(config)
        ) {
          store.dispatch({ type: UserActionTypes.SIGN_OUT });
          if (
            typeof window !== "undefined" &&
            window.location.pathname !== "/"
          ) {
            window.location.assign("/");
          }
        }

        return Promise.reject(error);
      }
    );

    return this.axiosInstance;
  }

  getInstance() {
    return this.axiosInstance || this.initInstance();
  }
}

export default new AxiosService();
